var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgInstruction(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 73.713,
    height: 81.16,
    viewBox: "0 0 73.713 81.16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Path_343",
    x: 0,
    y: 0,
    width: 66.699,
    height: 74.169,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#ffe8b9"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Path_344",
    x: 7.365,
    y: 7.252,
    width: 51.972,
    height: 32.773,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5,
    result: "blur-2"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#ffe8b9"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-2"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Path_345",
    x: 7.367,
    y: 14.553,
    width: 51.96,
    height: 32.774,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5,
    result: "blur-3"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#ffe8b9"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-3"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Path_346",
    x: 7.367,
    y: 21.856,
    width: 51.96,
    height: 32.774,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5,
    result: "blur-4"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#ffe8b9"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-4"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Path_347",
    x: 7.361,
    y: 29.159,
    width: 44.675,
    height: 32.773,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5,
    result: "blur-5"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#ffe8b9"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-5"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Path_348",
    x: 32.765,
    y: 36.571,
    width: 32.737,
    height: 36.278,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5,
    result: "blur-6"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#ffe8b9"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-6"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Ellipse_89",
    x: 32.765,
    y: 44.169,
    width: 32.737,
    height: 32.737,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5,
    result: "blur-7"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#ffe8b9"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-7"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Path_349",
    x: 24.555,
    y: 32.002,
    width: 49.158,
    height: 49.158,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5,
    result: "blur-8"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#ffe8b9"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-8"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_597",
    "data-name": "Group 597",
    transform: "translate(-582.506 -323.291)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 582.51, 323.29)",
    filter: "url(#Path_343)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_343-2",
    "data-name": "Path 343",
    d: "M633.511,338.291a2.721,2.721,0,0,1,.694,2q-.023,12.706-.007,25.411c0,.975-.051,2.039-1.307,2.028-1.277-.011-1.449-1.087-1.45-2.123q-.008-11.318-.007-22.637c0-1.953-.007-1.959-1.916-1.959-9.143,0-18.287.024-27.43-.028-1.378-.008-1.85.369-1.844,1.8q.074,17.6,0,35.2c-.005,1.364.452,1.741,1.771,1.724,4.96-.065,9.921-.027,14.882-.025.437,0,.877-.011,1.312.031a1.292,1.292,0,0,1,1.341,1.27c.043.9-.529,1.308-1.338,1.434a6.653,6.653,0,0,1-1.019.041q-8.608,0-17.217,0c-2.152,0-2.464-.313-2.464-2.439q-.005-19.716-.009-39.431a2.916,2.916,0,0,1,.694-2.294Z",
    transform: "translate(-582.51 -323.29)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 582.51, 323.29)",
    filter: "url(#Path_344)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_344-2",
    "data-name": "Path 344",
    d: "M633.592,365.749q-4.52,0-9.039,0c-.986,0-1.982-.108-1.974-1.375.008-1.247,1-1.394,1.985-1.395q8.966-.008,17.932,0c.146,0,.292,0,.437.012.918.073,1.664.4,1.617,1.468-.044.978-.759,1.281-1.627,1.283q-4.665.009-9.33,0Z",
    transform: "translate(-600.21 -340.73)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 582.51, 323.29)",
    filter: "url(#Path_345)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_345-2",
    "data-name": "Path 345",
    d: "M633.573,390.606h-8.893c-1.016,0-2.109-.029-2.095-1.4.013-1.242,1.03-1.372,2.006-1.373q8.966-.007,17.932,0c.974,0,2,.12,2.022,1.358.029,1.367-1.057,1.414-2.079,1.414Q638.019,390.6,633.573,390.606Z",
    transform: "translate(-600.22 -358.28)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 582.51, 323.29)",
    filter: "url(#Path_346)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_346-2",
    "data-name": "Path 346",
    d: "M633.57,415.466h-8.893c-1.017,0-2.109-.031-2.093-1.4.015-1.242,1.033-1.369,2.008-1.37q8.966-.007,17.932,0c.974,0,2,.122,2.02,1.36.027,1.367-1.06,1.412-2.081,1.411Q638.017,415.464,633.57,415.466Z",
    transform: "translate(-600.22 -375.84)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 582.51, 323.29)",
    filter: "url(#Path_347)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_347-2",
    "data-name": "Path 347",
    d: "M629.919,440.325q-2.769,0-5.538,0c-.964,0-1.835-.224-1.818-1.386s.912-1.375,1.856-1.378q5.465-.014,10.93,0c.939,0,1.856.2,1.888,1.345.036,1.262-.925,1.424-1.926,1.422C633.514,440.322,631.716,440.325,629.919,440.325Z",
    transform: "translate(-600.2 -393.4)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 582.51, 323.29)",
    filter: "url(#Path_348)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_348-2",
    "data-name": "Path 348",
    d: "M711.764,465.893c0,.631.043,1.266-.011,1.892a1.277,1.277,0,0,1-1.328,1.279,1.23,1.23,0,0,1-1.3-1.15,27.457,27.457,0,0,1-.014-3.921,1.24,1.24,0,0,1,1.393-1.2,1.3,1.3,0,0,1,1.262,1.354c.038.58.008,1.165.008,1.747Z",
    transform: "translate(-661.28 -411.22)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 582.51, 323.29)",
    filter: "url(#Ellipse_89)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_89-2",
    "data-name": "Ellipse 89",
    cx: 1.369,
    cy: 1.369,
    r: 1.369,
    transform: "translate(47.77 59.17)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 582.51, 323.29)",
    filter: "url(#Path_349)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_349-2",
    "data-name": "Path 349",
    d: "M690.676,466.391a9.579,9.579,0,1,1,9.579-9.579A9.59,9.59,0,0,1,690.676,466.391Zm0-16.808a7.229,7.229,0,1,0,7.229,7.229A7.237,7.237,0,0,0,690.676,449.583Z",
    transform: "translate(-641.54 -400.23)",
    fill: "#fff"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstruction);
export default __webpack_public_path__ + "static/media/instruction.93cef173f0e988895018328c9732ef18.svg";
export { ForwardRef as ReactComponent };